// extracted by mini-css-extract-plugin
module.exports = {"container":"CreditComponent_container__1ejy6","link":"CreditComponent_link__3UvNn"};